import { useAtom } from 'jotai';
import Image from 'next/legacy/image';

import shareIcon from '/public/images/graduate/share_icon.svg';
import { graduateShareModalAtom } from '@/store/v2/graduate';

import * as S from './style';

export default function Share() {
  const [, setShareModal] = useAtom(graduateShareModalAtom);
  return (
    <>
      <S.Wrapper>
        <S.TextWrapper>
          <S.Title>
            이 페이지를 공유하고
            <br /> 기쁨을 함께 나눠보세요.
          </S.Title>
          {/* <S.Info>*/}
          {/*  *수료 후기글 작성 후{" "}*/}
          {/*  <a*/}
          {/*    href="https://docs.google.com/forms/d/e/1FAIpQLSfdaOw13TEH5W0puz60emh2JMGOcQ7YIgpakuO94nJn0lwOHA/viewform"*/}
          {/*    target="_blank"*/}
          {/*    rel="noreferrer"*/}
          {/*  >*/}
          {/*    구글폼*/}
          {/*  </a>*/}
          {/*  을 제출하시면, 수료 축하 선물을 드립니다.*/}
          {/* </S.Info>*/}
        </S.TextWrapper>
        <S.ShareButton onClick={() => setShareModal(true)}>
          자랑하기
          <S.ShareImg>
            <Image src={shareIcon} layout='fill' objectFit='contain' />
          </S.ShareImg>
        </S.ShareButton>
      </S.Wrapper>
      {/* <S.MobileInfo>*/}
      {/*  *수료 후기글 작성 후{" "}*/}
      {/*  <a*/}
      {/*    href="https://docs.google.com/forms/d/e/1FAIpQLSfdaOw13TEH5W0puz60emh2JMGOcQ7YIgpakuO94nJn0lwOHA/viewform"*/}
      {/*    target="_blank"*/}
      {/*    rel="noreferrer"*/}
      {/*  >*/}
      {/*    구글폼*/}
      {/*  </a>*/}
      {/*  을 제출하시면, 수료 축하 선물을 드립니다.*/}
      {/* </S.MobileInfo>*/}
    </>
  );
}
